import { ArrowIcon } from "assets/icons";
import cn from "classnames";

import { RangePickerProps } from "./RangePicker.types";

import styles from "./RangePicker.module.scss";

const RangePicker = ({
  width,
  value,
  onChange,
  min = 0,
  max = 999999,
  disabled = false
}: RangePickerProps) => {
  return (
    <div
      className={cn(styles.rangePicker, {
        [styles.rangePicker__disabled]: disabled
      })}
      style={{ width: width ?? "100%" }}
    >
      <div className={styles.rangePicker_controls}>
        <button
          className={cn(styles.rangePicker_btn, styles.rangePicker_btn__up)}
          disabled={value.from >= value.to - 1}
          onClick={() => onChange({ ...value, from: value.from + 1 })}
        >
          <ArrowIcon />
        </button>

        <button
          className={styles.rangePicker_btn}
          onClick={() => onChange({ ...value, from: value.from - 1 })}
          disabled={value.from <= min}
        >
          <ArrowIcon />
        </button>
      </div>

      {value.to === 999999 ? (
        <span>{value.from}+</span>
      ) : (
        <>
          <span>{value.from}</span> - <span>{value.to}</span>
        </>
      )}

      <div className={styles.rangePicker_controls}>
        <button
          className={cn(styles.rangePicker_btn, styles.rangePicker_btn__up)}
          onClick={() => onChange({ ...value, to: value.to + 1 })}
          disabled={value.to >= max - 1}
        >
          <ArrowIcon />
        </button>

        <button
          className={styles.rangePicker_btn}
          onClick={() => onChange({ ...value, to: value.to - 1 })}
          disabled={value.to <= value.from + 1}
        >
          <ArrowIcon />
        </button>
      </div>
    </div>
  );
};

export default RangePicker;
